import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { JobLogStepSchema } from "@/types";
import { FEEDBACK_LINK } from "@/util";
import { jobApiStore, jobStore } from "@/hooks";
import { TextButton, Modal, Typography } from "@/components/common";

/**
 * Routes the user to the feedback page.
 */

/**
 * Displays a modal with logs for the currently selected job.
 */
const __default__ = {
  name: "JobLogModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

function handleFeedback(): void {
  window.open(FEEDBACK_LINK);
}

return (_ctx: any,_cache: any) => {
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_timeline_entry = _resolveComponent("q-timeline-entry")!
  const _component_q_virtual_scroll = _resolveComponent("q-virtual-scroll")!
  const _component_q_timeline = _resolveComponent("q-timeline")!

  return (_openBlock(), _createBlock(_unref(Modal), {
    open: _unref(jobApiStore).jobLog.length > 0,
    size: "xl",
    title: "Logs",
    onClose: _unref(jobApiStore).handleCloseLogs
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        icon: "graph-refresh",
        label: "Reload Logs",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(jobApiStore).handleViewLogs(_unref(jobStore).selectedJob!)))
      }),
      _createVNode(_unref(TextButton), {
        text: "",
        icon: "download",
        label: "Download Logs",
        onClick: _unref(jobApiStore).handleDownloadLogs
      }, null, 8, ["onClick"]),
      _createVNode(_unref(TextButton), {
        color: "negative",
        icon: "logs",
        label: "Report a Bug",
        text: "",
        onClick: handleFeedback
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_timeline, { "data-cy": "text-job-log" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_virtual_scroll, {
            items: _unref(jobApiStore).jobLog,
            separator: "",
            style: {"max-height":"70vh"}
          }, {
            default: _withCtx(({ item, index }: { item: JobLogStepSchema; index: number }) => [
              (!!item.entry)
                ? (_openBlock(), _createBlock(_component_q_timeline_entry, {
                    key: index,
                    color: item.error ? 'negative' : 'positive',
                    subtitle: item.timestamp
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_expansion_item, {
                        label: item.stepName,
                        class: "text-h5",
                        "default-opened": "",
                        "switch-toggle-side": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Typography), {
                            "collapse-length": 0,
                            value: item.entry,
                            "default-expanded": "",
                            l: "3",
                            variant: "expandable"
                          }, null, 8, ["value"])
                        ]),
                        _: 2
                      }, 1032, ["label"])
                    ]),
                    _: 2
                  }, 1032, ["color", "subtitle"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open", "onClose"]))
}
}

})